module.exports = __webpack_public_path__ + "static/media/feature2ats.74d70b9b.png";